export default __webpack_public_path__ + "dist/media/Point.46c233a3.svg";